import { h, icons } from '../dom'
import type { WidgetState } from '../state'
import { t } from '../i18n'

/**
 * The floating button: the SpotNote tile, in whichever corner the project
 * chose. It pulses only until the first note exists, so it invites a first
 * click and then gets out of the way.
 */
export function renderLauncher(state: WidgetState, onOpen: () => void): HTMLElement | null {
  const config = state.config
  if (!config) return null

  const unsent = state.notes.length
  const pulse = !state.sent && unsent === 0 ? 'pulse' : ''

  const button = h('button', {
    class: `launcher corner-${config.widget_corner} ${pulse}`.trim(),
    type: 'button',
    'aria-label':
      unsent > 0 ? t().launcherAriaUnsent(unsent) : state.sent ? t().launcherAriaSent : t().launcherAria,
    onclick: onOpen,
    html: icons.starLarge,
  })

  // Notes saved but not sent stay counted on the tile after the toolbar is
  // closed, so they cannot be forgotten quietly.
  if (unsent > 0) {
    button.appendChild(h('span', { class: 'unsent-count', 'aria-hidden': 'true', text: String(unsent) }))
  }

  return button
}
